import { render, staticRenderFns } from "./UnlinkUserBtn.vue?vue&type=template&id=06222d02&"
import script from "./UnlinkUserBtn.vue?vue&type=script&lang=js&"
export * from "./UnlinkUserBtn.vue?vue&type=script&lang=js&"
import style0 from "./UnlinkUserBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports